import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { Tooltip } from '../tooltip/tooltip';
import { AudioVisualizer, IAudioVisualizerProps } from './audio-visualizer';
import { ColorPalette } from '../config';

interface AudioVisualizerIconProps extends IAudioVisualizerProps {
  icon: IconProp;
  name: string;
  iconSize?: SizeProp;
  color?: string;
}

export function AudioVisualizerIcon({
  icon,
  name,
  analyserNode,
  iconSize = 'xl',
  height,
  width,
  disabled,
  color = ColorPalette.PrimaryMain,
}: AudioVisualizerIconProps): JSX.Element {
  return (
    <>
      <Tooltip title={name}>
        <FontAwesomeIcon size={iconSize} style={{ paddingLeft: '10px' }} icon={icon} color={color} />
      </Tooltip>
      <AudioVisualizer analyserNode={analyserNode} height={height} width={width} disabled={disabled} />
    </>
  );
}
